import { useContextState } from "../../../../../../../../../../hooks/theme"
import { FontName } from "../../../../../../../../../../utils/enums/font"


export const useStyles = () => {
    const { colors: color } = useContextState()

    return {
        mainContainer: {
            display: 'flex',
            gap: 3,
            height: '100%',
            '& .child': {
                width: '47%',
                minHeight: '100%',
            },
            '& .left': {
                paddingRight: 3,
                borderRight: `1px solid ${color.color13}`,
            }
        },
        title: {
            fontWeight: 'bold',
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
            '&.mb': {
                marginBottom: 3
            }
        },
        destionationBox: {
            marginBottom: 2,
            display: 'flex',
            boxShadow: '0px 6px 10px -2px rgba(0, 0, 0, 0.18)',
            borderRadius: 1,
            alignItems: 'center',
            padding: '12px'
        },
        direction: {
            fontSize: '14px',
            color: color.color13,
            fontFamily: FontName.RobotoRegular,
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
        },
        gerent: {
            fontSize: '14px',
            fontFamily: FontName.RobotoRegular,
            overflowWrap: 'break-word',
            wordBreak: 'break-word',
        },
        destinationsList: {
            height: '65%',
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollbarWidth: 'none'
        },
        check: {
            '& .MuiBox-root': {
                height: '25px',
                width: '25px'
            }
        },
        text: {
            color: color.color13,
            textAlign: 'center',
        },
        noActivities: {
            display: 'flex',
            padding: '100px 16px 16px 16px',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            '& .MuiSvgIcon-root': {
                color: color.color13
            },
            marginTop: '-24px'
        },
        mapContainer: {
            height: '90%',
            width: '100%',
            display: 'flex'
        },
        cleanFilters: {
            fontSize: '14px',
            cursor: 'pointer',
            color: color.color16,
            minHeight: '35px',
            marginTop: '10px',
            display: 'flex',
            alignItems: 'center',
        },
        butonsContainer:{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 2,
        }
    }
}